import { committed, readAll } from '../idb';
import { STORE_MIGRATIONS } from '../stores';
export function ensureMigrationStore(db) {
    if (!db.objectStoreNames.contains(STORE_MIGRATIONS)) {
        db.createObjectStore(STORE_MIGRATIONS, { keyPath: 'id' });
    }
}
export async function pendingMigrations(db, migrations) {
    const applied = new Set((await readAll(db, STORE_MIGRATIONS)).map((row) => row.id));
    return migrations.filter((migration) => !applied.has(migration.id));
}
function currentBatch(applied, migrations) {
    const batch = [];
    for (const migration of migrations) {
        if (applied.has(migration.id))
            continue;
        batch.push(migration);
        if (migration.data !== undefined)
            break;
    }
    return batch;
}
export function runSchemaPhase(db, transaction, migrations, logger) {
    const store = transaction.objectStore(STORE_MIGRATIONS);
    const request = store.getAllKeys();
    request.onsuccess = () => {
        const applied = new Set(request.result);
        for (const migration of currentBatch(applied, migrations)) {
            if (migration.schema === undefined)
                continue;
            migration.schema(db);
            logger.debug(`[migrations] Applied schema phase of ${migration.id}.`);
        }
    };
}
export async function runDataPhase(context, migrations) {
    const applied = new Set((await readAll(context.db, STORE_MIGRATIONS)).map((row) => row.id));
    for (const migration of currentBatch(applied, migrations)) {
        await migration.data?.(context);
        const transaction = context.db.transaction([STORE_MIGRATIONS], 'readwrite');
        transaction.objectStore(STORE_MIGRATIONS).put({ id: migration.id });
        await committed(transaction);
        context.logger.debug(`[migrations] Applied ${migration.id}.`);
    }
}
